import React from 'react';

export const Badge = ({
  children,
  variant = 'default', // 'teal', 'success', 'warning', 'danger', 'info', 'purple', 'neutral', 'recessed'
  size = 'sm', // 'xs', 'sm', 'md'
  icon,
  className = '',
  style = {},
  ...props
}) => {
  const sizeStyles = {
    xs: { padding: '2px 6px', fontSize: '10px', fontWeight: '600' },
    sm: { padding: '4px 10px', fontSize: '11px', fontWeight: '600' },
    md: { padding: '6px 14px', fontSize: '13px', fontWeight: '600' }
  }[size];

  const getVariantStyles = () => {
    switch (variant) {
      case 'teal':
        return {
          backgroundColor: 'rgba(35, 190, 179, 0.15)',
          color: 'var(--accent-teal)',
          border: '1px solid rgba(35, 190, 179, 0.35)'
        };
      case 'success':
        return {
          backgroundColor: 'rgba(56, 184, 120, 0.15)',
          color: 'var(--color-success)',
          border: '1px solid rgba(56, 184, 120, 0.35)'
        };
      case 'warning':
        return {
          backgroundColor: 'rgba(216, 155, 61, 0.15)',
          color: 'var(--color-warning)',
          border: '1px solid rgba(216, 155, 61, 0.35)'
        };
      case 'danger':
        return {
          backgroundColor: 'rgba(214, 92, 103, 0.15)',
          color: 'var(--color-danger)',
          border: '1px solid rgba(214, 92, 103, 0.35)'
        };
      case 'info':
        return {
          backgroundColor: 'rgba(88, 142, 219, 0.15)',
          color: 'var(--color-info)',
          border: '1px solid rgba(88, 142, 219, 0.35)'
        };
      case 'purple':
        return {
          backgroundColor: 'rgba(138, 112, 214, 0.15)',
          color: 'var(--color-purple)',
          border: '1px solid rgba(138, 112, 214, 0.35)'
        };
      case 'recessed':
        return {
          backgroundColor: 'var(--surface-recessed)',
          boxShadow: 'var(--shadow-recessed-sm)',
          color: 'var(--text-secondary)',
          border: '1px solid var(--border-subtle)'
        };
      case 'neutral':
      default:
        return {
          backgroundColor: 'var(--surface-alt)',
          color: 'var(--text-secondary)',
          border: '1px solid var(--border-subtle)'
        };
    }
  };

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        borderRadius: 'var(--radius-full)',
        lineHeight: 1.2,
        letterSpacing: '0.02em',
        userSelect: 'none',
        whiteSpace: 'nowrap',
        ...sizeStyles,
        ...getVariantStyles(),
        ...style
      }}
      className={`badge-pill ${className}`}
      {...props}
    >
      {icon && <span style={{ display: 'inline-flex', fontSize: '1.2em' }}>{icon}</span>}
      {children}
    </span>
  );
};
